import { mapState } from 'vuex'
import cloneDeep from 'lodash.clonedeep'

export default {
  data () {
    return {
      defaultSelect: true // 组织/工厂默认选第一个
    }
  },
  computed: {
    ...mapState({
      cacheHistory: (state) => state.pageHistory.cashHistory
    })
  },
  methods: {
    /**
     *  处理缓存查询逻辑
     * @param refName 查询定义的ref
     * @param defaultSelectField 初始化选择的组织或工厂字段
     * @param dates 日期范围条件处理，入参例子: {scheduledCompletionDate: ['staScheduledCompletionDate', 'endScheduledCompletionDate']}
     * @param dateIsModelForm 日期范围条件是否绑定在form,如果为true要setFieldsValue回写，默认为true
     * @param reSearch 重新查询方法
     */
    getHistoryCache (refName, defaultSelectField, dates, dateIsModelForm = true, reSearch) {
      if (!refName) { return false }
      // 处理缓存逻辑
      if (this.cacheHistory && this.cacheHistory[this.$route?.fullPath]) {
        const dateObj = {} // 需要重新回写的日期对象
        this.queryParams = this.cacheHistory[this.$route?.fullPath]
        // 默认选择的组织/工厂处理
        if (defaultSelectField && this.queryParams[defaultSelectField]) { this.defaultSelect = false; }
        // 日期条件处理
        if (dates) {
          const dateList = Object.keys(dates)
          if (dateList.length > 0) {
            dateList.forEach(item => {
              if (dates[item][0] && dates[item][1] && this.queryParams[dates[item][0]] && this.queryParams[dates[item][1]]) {
                if (dateIsModelForm) {
                  dateObj[item] = [this.$moment(this.queryParams[dates[item][0]]), this.$moment(this.queryParams[dates[item][1]])] // 绑定在form
                } else {
                  this[item] = [this.$moment(this.queryParams[dates[item][0]]), this.$moment(this.queryParams[dates[item][1]])] // 单独绑定的日期
                }
              }
            })
          }
        }
        this.$nextTick(() => {
          if (this.$refs[refName]?.form) {
            this.$refs[refName].form.setFieldsValue({ ...this.queryParams, ...dateObj })
          }
          // 是否要重新查询
          if(reSearch !== undefined && typeof reSearch === 'function') {
            reSearch()
          }
        })
      }
    },
    /**
     * 获取缓存数据(没有通过$form.createForm)
     * @param defaultSelectField
     * @param dates 日期范围条件处理，入参例子: {scheduledCompletionDate: ['staScheduledCompletionDate', 'endScheduledCompletionDate']}
     */
    getCacheNoRef(defaultSelectField, dates) {
      // 处理缓存逻辑
      if (this.cacheHistory && this.cacheHistory[this.$route?.fullPath]) {
        this.queryParams = this.cacheHistory[this.$route?.fullPath]
        // 默认选择的组织/工厂处理
        if (defaultSelectField && this.queryParams[defaultSelectField]) { this.defaultSelect = false; }
        // 日期条件处理
        if (dates) {
          const dateList = Object.keys(dates)
          if (dateList.length > 0) {
            dateList.forEach(item => {
              if (dates[item][0] && dates[item][1] && this.queryParams[dates[item][0]] && this.queryParams[dates[item][1]]) {
                this[item] = [this.$moment(this.queryParams[dates[item][0]]), this.$moment(this.queryParams[dates[item][1]])] // 单独绑定的日期
              }
            })
          }
        }
      }
    },
    /**
     * 设置缓存
     * @param params
     */
    setSearchCache(params) {
      this.$store.commit('setCashHistory', { path: this.$route.fullPath, data: cloneDeep(params) })
    }
  }
}
